import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Navigate } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';
import { styled } from '@mui/material/styles';
import axios from "axios";
import "./styles.css";
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Switch,
  FormControlLabel,
  FormGroup,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import ClanKerovi from '../pages/ClanKerovi';
import HunterReport from './HunterReport';
import SubscriberCreate from '../pages/SubscriberCRUDPages/create';

import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

const TABLE_HEAD = [
  { id: 'id', label: 'Broj', alignRight: false },
  { id: 'ime', label: 'Ime', alignRight: false },
  { id: 'prezime', label: 'Prezime', alignRight: false },
  { id: 'mjesto', label: 'Mjesto', alignRight: false },
  { id: 'drzava', label: 'Država', alignRight: false },
  { id: 'username', label: 'Userneme', alignRight: false },
  { id: 'password', label: 'Password', alignRight: false },
  { id: 'datumregistracije', label: 'Registrovan', alignRight: false },
  { id: 'update', label: 'Update', alignRight: false },
  { id: 'show', label: 'Show/Hide', alignRight: false },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, field) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
	if (field === 'ime')
    return filter(array, (_user) => (_user.ime.toLowerCase()+ ' ' +_user.prezime.toLowerCase()).indexOf(query.toLowerCase()) !== -1);

	if (field === 'prezime')
    return filter(array, (_user) => _user.prezime.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'telefon')
    return filter(array, (_user) => _user.telefon.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'mjesto')
    return filter(array, (_user) => _user.mjesto.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'drzava')
    return filter(array, (_user) => _user.drzava.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'username')
    return filter(array, (_user) => _user.username.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
    // A function that increment 👆🏻 the previous state like here 
    // is better than directly setting `setValue(value + 1)`
}

export default function HuntersReportAll() {
	
  const [subscriberid, setSubscriberId] = useState(0);
	
  const [loading, setLoading] = useState(false);
	
  const [id, setId] = useState('');
	
  const [opened, setOpened] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');
  
  const [subscribers, setSubscribers] = useState([]);
    
  const [izabran, setIzabran] = useState('');
  
  const [dataloaded, setDataLoaded] = useState(false);

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);
  
  const { user: currentUser } = useSelector((state) => state.auth);
  
  const [checked, setChecked] = useState(true);
  
  const forceUpdate = useForceUpdate();
  
  useEffect(() => {
	console.log(dataloaded);
	if (!dataloaded) {
    getAllSubscribers();

    const role = currentUser.roles[0];
    const rolenumber = role.slice(10);
  
	}
  });
  
  const getAllSubscribers = async () => {
      try {
        const response = await axios.get("https://gpsdogstracking.com:3000/api/subscribers");
        await setSubscribers(response.data);
		setDataLoaded(true);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
  };
  
  const handleRefresh = (event, id) => {  
	getAllSubscribers();
  };
	
  console.log(currentUser);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  const setData = (data) => {
  console.log(data);
  
  const { id, ime, prezime, telefon, godiste, mjesto, drzava } = data;
  
  console.log(id);
  
  localStorage.setItem('id', id);
  localStorage.setItem('ime', ime);  
  localStorage.setItem('prezime', prezime);
  localStorage.setItem('telefon', telefon);
  localStorage.setItem('godiste', godiste);
  localStorage.setItem('mjesto', mjesto);
  localStorage.setItem('drzava', drzava);
  }
  
  const handleOpenMenu = (event) => {
    setOpened(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpened(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
	console.log(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = subscribers.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  
  const handleClickShow = (event, id) => {
	console.log(id);
	setSubscriberId(id);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - subscribers.length) : 0;

  const filteredSubscribers = applySortFilter(subscribers, getComparator(order, orderBy), filterName, orderBy);

  const isNotFound = !filteredSubscribers.length && !!filterName;
  
  var today = new Date();

  const datum ='Datum: ' +  today.getDate()  + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + '. god.';

Font.register({
  family: "Roboto",
  src:
    "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf"
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto"
  },
  body: {
    paddingTop: 50,
    paddingBottom: 65,
    paddingHorizontal: 30,
	fontFamily: "Roboto", 
	fontSize: 10,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Roboto'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Roboto'
  },
  text: {
    margin: 5,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmedium: {
    margin: 3,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmediumlarge: {
    margin: 12,
    fontSize: 20,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  textbig: {
    margin: 12,
    fontSize: 28,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  officer: {
	paddingTop: 70,
    fontSize: 12,
	margin: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
	left: 150,
  },
  officertext: {
    margin: 0,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Roboto',
  },
  mp: {
    position: 'absolute',
    fontSize: 12,
    bottom: 100,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid",  
    borderRightWidth: 0, 
	borderLefttWidth: 0, 
    borderTopWidth: 0,
	borderBottomWidth: 0,
  }, 
  tableRow: { 
    margin: "0", 
    flexDirection: "row",
	 borderWidth: 0,
  }, 
  tableCol: { 
    width: "20%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  }, 
  tableColLong: { 
    width: "30%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColShort: { 
    width: "15%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColVeryShort: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableCell: { 
    margin: "auto", 
    marginTop: 5, 
    fontSize: 10 
  },
});

  const SubscribersReportAll = () => (
	<Document>
    <Page size="A4" orientation="portrait" scale={0.5} style={styles.body} wrap>
		<Text style={styles.textmedium}>{datum}</Text>
	
	<Svg style={styles.text} width="800" height="100" viewBox="0 0 800 100">
		<Text style={styles.textmediumlarge} x="100" y="80">Pregled evidencije pretplatnika</Text>
	</Svg>	
	
	<View wrap style={styles.body}> 
      <View style={styles.table}> 
        <View wrap={false} style={styles.tableRow}> 
          <View style={styles.tableColVeryShort}> 
            <Text style={styles.tableCell}>Broj</Text> 
          </View> 
          <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Ime</Text> 
          </View> 
	      <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Prezime</Text> 
          </View> 
          <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Mjesto</Text> 
          </View> 
          <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Država</Text> 
          </View> 
        </View>
		
    {filteredSubscribers.map((hunter, index) => (
	
	true && ( 
		<View key = {hunter.id} wrap={false} style={styles.tableRow}> 
          <View wrap={false} style={styles.tableColVeryShort}> 
            <Text style={styles.tableCell}>{index + 1}.</Text> 
          </View> 
          <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{hunter.ime}</Text> 
          </View> 
          <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{hunter.prezime}</Text> 
          </View> 
          <View wrap={false} style={styles.tableColLong}>
            <Text style={styles.tableCell}>{hunter.mjesto}</Text> 
          </View>
          <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{hunter.drzava}</Text> 
          </View> 
        </View> 
	  )
    ))}
      </View>
	</View>
	  
    <View size="A4" style={styles.officer}>	 
	<Text size="A4" style={styles.officertext} >______________________________</Text>
	<Text size="A4" style={styles.officertext} >(Knjigovođa)</Text>
	</View>	
	
	<Text size="A4" style={styles.mp}>
		M.P.
	</Text>

    <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
    />
    </Page>
	</Document>
  )
  
  return (
    <>
      <Helmet>
        <title> GPS Dogs Tracking System </title>
      </Helmet>
	  
      <Container maxWidth="xl">
		<Typography variant="subtitle2" noWrap>
			Pregled evidencije pretplatnika
		</Typography>

        <Card>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
				  color='#002884'
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={filteredSubscribers.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredSubscribers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, ime, prezime, telefon, godiste, mjesto, drzava, username, password, datumregistracije, blokiran } = row;  
					
                    const selectedUser = selected.indexOf(id) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
					    <TableCell component="th" scope="row" >
						  <Typography variant="subtitle2" noWrap>
							{id}
                          </Typography>
                        </TableCell>
					  
                        <TableCell component="th" scope="row" >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={ime} src={"/assets/images/photos/photo_" + id + ".jpg"} />
                          </Stack>
                        </TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{ime}
						</Typography>
						</TableCell>

                        <TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{prezime}
						</Typography>
						</TableCell>	

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{mjesto}
						</Typography>
						</TableCell>	

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{drzava}
						</Typography>
						</TableCell>	

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{username}
						</Typography>
						</TableCell>

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{password}
						</Typography>
						</TableCell>	

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{datumregistracije}
						</Typography>
						</TableCell>							
												
						<TableCell> 
						<Link to='/SLOBiHClanovi/update'>
						<Button onClick={() => setData(row)}>Update</Button>
						</Link>
						</TableCell>
						
						<TableCell> 
						<Button onClick={(event) => handleClickShow(event, id)}>Show</Button>
						</TableCell>
						
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredSubscribers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
				
		<br />
		
		<Button onClick={() => setLoading(!loading)}>Generate Report</Button>
		
		{loading ? ( 
		<div className = "child">	 
		<PDFViewer className = "child">
		<SubscribersReportAll />
		</PDFViewer>
		</div>	
		)
		:
		(
		<>
		</>
		)
		}
 
      </Container>
	  
	  <br />
	  
	  <div>
			<ClanKerovi vlasnik = {subscriberid}/>	  
	  </div>

    </>
  );
}
